import { Auth } from 'aws-amplify';
import { AmplifyTheme } from 'aws-amplify-react';

const getAuthorizationHeader = async (): Promise<Record<string, string>> => {
  try {
    const token = (await Auth.currentSession()).getIdToken().getJwtToken();

    return { Authorization: token };
  } catch {
    try {
      await Auth.signOut();
    } catch {}

    return {};
  }
};

export const myAmplifyConfig = {
  Auth: {
    identityPoolId: process.env.REACT_APP_COGNITO_IDENTITY,
    region: process.env.REACT_APP_COGNITO_REGION,
    userPoolId: process.env.REACT_APP_COGNITO_USER_POOL,
    userPoolWebClientId: process.env.REACT_APP_COGNITO_WEB_CLIENT,
    mandatorySignIn: true
  },
  API: {
    endpoints: [
      {
        name: 'api-cms',
        endpoint: `${process.env.REACT_APP_CMS_URL}`
      },
      {
        name: 'service-mtpf',
        endpoint: `${process.env.REACT_APP_SERVICE_MTPF_URL}/v1`,
        custom_header: getAuthorizationHeader
      }
    ]
  }
};

export const myAmplifyTheme = {
  ...AmplifyTheme,
  BackgroundColor: { color: 'red', backgroundColor: 'orange' },
  button: { color: 'white', backgroundColor: '#3061f3' },
  sectionHeader: {
    ...AmplifyTheme.sectionHeader,
    color: 'white',
    backgroundColor: 'black'
  }
};

export const myAmplifySignupConfig = {
  header: 'Match the Promise Fund Account setup',
  signUpFields: [
    {
      label: 'Username',
      key: 'username',
      required: true,
      displayOrder: 1,
      type: 'string'
    },
    {
      label: 'First Name',
      key: 'given_name',
      required: true,
      displayOrder: 2,
      type: 'string'
    },
    {
      label: 'Last Name',
      key: 'family_name',
      required: true,
      displayOrder: 3,
      type: 'string'
    },
    {
      label: 'Email',
      key: 'email',
      required: true,
      displayOrder: 4,
      type: 'string'
    },
    {
      label: 'Phone Number',
      key: 'phone_number',
      required: true,
      displayOrder: 5,
      type: 'phone'
    },
    {
      label: 'Password',
      key: 'password',
      required: true,
      displayOrder: 6,
      type: 'password'
    }
  ]
};
